import React from 'react';
import { useWeather } from '../../context';
import { Select } from '../ui/Select';

export function ResolutionSelector() {
  const { modelSelect, resolution, setResolution } = useWeather();

  // Only show for OpenMeteo
  if (modelSelect !== 'openmeteo') {
    return null;
  }

  const options = [
    { value: '0.0125', label: '0.0125° (~1.4 km)' },
    { value: '0.025', label: '0.025° (~2.8 km)' },
    { value: '0.05', label: '0.05° (~5.6 km)' },
    { value: '0.1', label: '0.1° (~11.1 km)' }
  ];

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setResolution(Number(e.target.value));
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
        Grid Resolution
      </label>
      <Select
        value={resolution ? resolution.toString() : '0.0125'}
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}